// extracted by mini-css-extract-plugin
export default {"pill":"h4VJy","pillText":"ziWEf","switchContainer":"L4evP","buttons":"qB9eW","selectedSide":"FOfM6","unselectedSide":"BU_NG"};